import { computed } from 'vue'
import { KNOLIA } from '@/knolia'
import { useUserStore } from '@/store/modules/user'
import { VALIDATION_LABEL, formatDate } from '@/utils/validation'

export function useValidationListView({ validateData, ratingSkillsModal }) {
  const userStore = useUserStore()

  const ratingType = computed({
    get() {
      return validateData.ratingType.value
    },
    set(newValue) {
      Object.assign(validateData.ratingType, { value: newValue })
    }
  })

  const userFilter = computed({
    get() {
      return validateData.userFilter.value
    },
    set(newValue) {
      Object.assign(validateData.userFilter, { value: newValue })
    }
  })

  const requestDateAsc = computed({
    get() {
      return validateData.requestDateAsc.value
    },
    set(newValue) {
      Object.assign(validateData.requestDateAsc, { value: newValue })
    }
  })

  const showOnlySelf = computed({
    get() {
      return validateData.showOnlySelf.value
    },
    set(newValue) {
      Object.assign(validateData.showOnlySelf, { value: newValue })
    }
  })

  async function getHistory(elem, history = false) {
    if (elem.showOtherValidators && !history) {
      elem.showOtherValidators = !elem.showOtherValidators
      return
    }

    await KNOLIA.CallBackEnd('get', 'get-operations', {
      params: {
        get: 'validation-history',
        only_validators: ratingSkillsModal.ShowChatValidators,
        elem: {
          skills_ratings_id: elem.skills_ratings_id,
          rating_type: elem.rating_type,
          validator_id: elem.validator_id,
          history_id: elem.history_id,
          history_skill_rating_id: elem.history_skill_rating_id,
          sitemap: elem.sitemap,
          designation: elem.designation,
          is_op_skill: elem.is_op_skill,
          has_unread_messages: elem.has_unread_messages,
          has_unread_messages_only_validators: elem.has_unread_messages_only_validators
        },
        history
      }
    }).then((res) => {
      if(history) {
        elem.history = res.data
        elem.showHistory = !elem.showHistory
      } else {
        elem.otherValidators = res.data
        elem.showOtherValidators = !elem.showOtherValidators
      } 
    })
  }

  function openHistoryItemModal(history) {
    ratingSkillsModal.OpenModalDocs(history.validators[history.selectedValidatorId])
  }

  function validateHistoryItem(history) {
    validateData.Validate(history.validators[history.selectedValidatorId])
  }

  function canPostValidation(elem) {
    if(elem.validation == 4) {
      return elem.without_validator ? elem.newValidatorId : true
    } else {
      return elem.validation != null && elem.validation < 3 && elem.validation_date == null && elem.validation !== ''
    }
  }

  return {
    userStore,
    ratingType,
    userFilter,
    requestDateAsc,
    VALIDATION_LABEL,
    formatDate,
    showOnlySelf,
    getHistory,
    openHistoryItemModal,
    validateHistoryItem,
    canPostValidation
  }
}
